export default "__VITE_ASSET__ff8bb548__"